export * from './src/Icon'
export * from './src/icons'
export * from "./src/themed.icon";